import { get, post } from '@/utils/request'
import apiMap from "@/config";

const riskApi = apiMap.riskApi

export const getList = data => get(`${riskApi}/risk/oddsDropGroup/list`, data)

export const getOddsDropDelete = data => post(`${riskApi}/risk/oddsDropGroup/delete`, data)

export const getOddsDropUpdate = data => post(`${riskApi}/risk/oddsDropGroup/update`, data)

export const getOddsDropAdd = data => post(`${riskApi}/risk/oddsDropGroup/add`, data)

export const getOddsDropOperationLog = data => get(`${riskApi}/risk/oddsDropGroup/historyList`, data)

export const oddsDropList = data => get(`${riskApi}/risk/oddsDropGroup/selectList`, data)

